<app-header title=""></app-header>
<div class="account-header mb-4 d-flex flex-column container pb-3 pl-4 font-family-settings">
  <span class="account-title">Settings</span>
  <span class="account-subtitle">Manage your organization and account settings</span>
</div>
<mdb-tabs #tabs class="mdb-tabs account-page font-family-settings"  (activeTabChange)="onTabChange($event)">
    <mdb-tab title="Organization Info" class="position-relative">
      <div class=" py-4" 
      [ngClass]="{
        'read-only': readonly,
        'background__color--white': !readonly
      }">
      @if(readonly){
        <span class="badge-warning caption custom-budge d-flex align-items-center justify-content-center position-absolute"
        style="top: 30px; right:40px"
        >Read Only Access</span>
      }
        <div class="container pb-3 pl-4">
            <div class="mb-4 d-flex flex-column">
                <div class="orgTab-title">Organization Information</div>
                <span class="orgTab-subtitle">General organization details</span>
            </div>
            <div class="w-100 mt-4 new-design-controls">
              <div class="d-flex flex-row py-4 mb-3" style="border-top: 1px solid RGB(217, 217, 217);">
                <span class="col-4 p-0 control-title">Organization Name <span class="purple-text">*</span></span>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0 ">
                    <app-mdbp-input mdbInput [formControl]="orgName" label='' [readonly]="readonly"></app-mdbp-input>
                    @if(buttons.name){
                      <div class="position-absolute" style="right: 0;bottom:-35px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('name')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('name')">Update</a>
                      </div>
                    }
                    @if(!orgName.valid){<span class="form-fill-error">Organization name cannot be empty</span>}
                  </mdb-form-control>
                </div>
              </div>
              <div class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Primary Email <span class="purple-text">*</span></span>
                </div>
                <div class="d-flex w-100  mb-5 align-items-center col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0 w-100 mr-2">
                    <app-mdbp-input mdbInput [formControl]="primaryEmail" label='Primary Email' [readonly]="readonly"></app-mdbp-input>
                    @if(buttons.primaryEmail){
                      <div class="position-absolute" style="right: 0;bottom:-35px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('primaryEmail')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('primaryEmail')">Update</a>
                      </div>
                    }
                    @if(!primaryEmail.valid){<span class="form-fill-error">{{getError('primaryEmail')}}</span>}
                  </mdb-form-control>
                  <!-- <app-text-popover
                    size="sm"
                    placement="bottom"
                    type="content"
                    text="This is the main email ID used to login to the account. All emails from PayBee will be sent to this email ID."
                    title=""
                  >
                  </app-text-popover> -->
                </div>
              </div>
              <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Support Email</span>
                  <span class="control-subtitle">All donor queries sent to PayBee that require a response from your team will be sent to this email ID.</span>
                </div>
                <div class="d-flex w-100  mb-5 align-items-center  col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0 w-100 mr-2">
                    <app-mdbp-input mdbInput [formControl]="supportEmail" label='Support Email' [readonly]="readonly"></app-mdbp-input>
                    @if(buttons.supportEmail){
                      <div class="position-absolute" style="right: 0;bottom:-35px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('supportEmail')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('supportEmail')">Update</a>
                      </div>
                    }
                    @if(!supportEmail.valid){<span class="form-fill-error">Invalid Email.</span>}
                  </mdb-form-control>
                  <!-- <app-text-popover
                    size="sm"
                    placement="bottom"
                    type="content"
                    text="All donor queries sent to PayBee that require a response from your team will be sent to this email ID."
                    title=""
                  >
                  </app-text-popover> -->
                </div>
              </div>
              <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Mission Statement <span class="purple-text">*</span></span>
                  <span class="control-subtitle">A short one-liner that will appear under the organization name</span>
                </div>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-5">
                    <app-mdbp-input mdbInput [formControl]="mission" label='' [readonly]="readonly"></app-mdbp-input>
                    @if(buttons.mission){
                      <div class="position-absolute" style="right: 0;bottom:-35px" >
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('mission')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('mission')">Update</a>
                      </div>
                    }
                    @if(!mission.valid){<span class="form-fill-error">Mission Statement cannot be empty</span>}
                  </mdb-form-control>
                </div>
              </div>

              <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Description</span>
                </div>
                <div class="col-8 p-0 pl-4">
                  <div style="position: relative;" class="mb-5"> 
                    <mdb-form-control>     
                      <app-quill-custom mdbInput [formControl]="desc" limit="2048" [readonly]="readonly"></app-quill-custom>
                      @if(buttons.desc){
                        <div class="position-absolute" style="right: 0;bottom:-40px">
                          <a class="mr-3 body-2 grey-text" (click)="onCanselClick('desc')">Cancel</a> 
                          <a class="body-2 purple-text" (click)="onUpdateClick('desc')">Update</a>
                        </div>
                      }
                    </mdb-form-control>
                </div>
                </div>
              </div>

              <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Website <span class="purple-text">*</span></span>
                </div>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-3">
                    <app-mdbp-input mdbInput [formControl]="url" label='' [readonly]="readonly"></app-mdbp-input>
                    @if(buttons.url){
                      <div class="position-absolute" style="right: 0; bottom:-35px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('url')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('url')">Update</a>
                      </div>
                    }
                    @if(!url.valid){<span class="form-fill-error">{{getError('url')}}</span>}
                  </mdb-form-control>
                </div>
              </div>

              <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Address <span class="purple-text">*</span></span>
                </div>
                <div class="col-5 p-0 pl-4 mb-3">
                  <span class="control-label mb-1">Street Address</span>
                  <mdb-form-control class="form-fill mb-0 appGoogleMapsAutocomplete d-flex form-fill--background" style="height: 44px!important;">
                      <app-mdb-input-google-maps-autocomplete
                        id="google-maps-autocomplete"
                        mdbInput
                        autocomplete="address"
                        label="Address"
                        [formControl]="address"
                        class="d-flex w-100"
                        [readonly]="readonly"
                      ></app-mdb-input-google-maps-autocomplete>
                  </mdb-form-control>
                  @if(!address.valid){
                      <span class="form-fill-error mr-2 ml-0" style="margin-top: 23px !important;">Address cannot be empty.</span>
                    }
                  @if(showEnterManualy){
                    <a (click)="onEnterManuallyClick()" class="body-2 text-purple">Enter Manually</a>
                  }
                </div>
                <div class="col-2  p-0 pl-4 mb-3">
                    <span class="control-label mb-1">Unit/Apt#</span>
                    <mdb-form-control class="form-fill mb-0 form-fill--background" style="height: 44px!important;">
                        <app-mdbp-input mdbInput [formControl]="unitNum" label='Unit/Apt#' [readonly]="readonly"></app-mdbp-input>
                    </mdb-form-control>
                    @if(buttons.address){
                      <div class="position-absolute" style="right: 0; bottom:-32px">
                        <!-- <a class="mr-3 body-2 grey-text" (click)="onCanselClick('address')">Cancel</a>  -->
                        <a class="body-2 purple-text" (click)="onUpdateClick('address')">Update</a>
                      </div>
                    }
                </div>
              </div>


              <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Phone Number <span class="purple-text">*</span></span>
                </div>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0" >
                    <app-mdbp-input mdbInput [formControl]="phone" autocomplete="tel" type='tel' [showMaxLength]="false" phoneInputMask="on" label='Phone Number' [readonly]="readonly"></app-mdbp-input>
                    @if(buttons.phone){
                      <div class="position-absolute" style="right: 0;bottom:-35px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('phone')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('phone')">Update</a>
                      </div>
                    }
                    @if(!phone.valid){<span class="form-fill-error">{{getError('phone')}}</span>}
                </mdb-form-control>
                </div>
              </div>
            </div>
        </div>
      </div>
    </mdb-tab>
    <mdb-tab title="Account">
      <div class="py-4"
        [ngClass]="{
          'read-only': readonly,
          'background__color--white': !readonly
        }">
        @if(readonly){
          <span  class="badge-warning caption custom-budge d-flex align-items-center justify-content-center position-absolute"
          style="top: 30px; right:40px"
          >Read Only Access</span>
        }
        <div class="container pb-5 pl-4" style="margin-bottom: 140px;">
            <div class="w-100 new-design-controls"> 
              <div class="mb-4 d-flex flex-column">
                <div class="orgTab-title">Account Settings</div>
              </div>
              <div class="d-flex flex-row py-4 mb-3" style="border-top: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-title">Donor Cover Fee Settings</span>
                  <span class="control-subtitle mb-1">Choose to have the donors optionally cover transaction fees alone or the transaction fees and platform fees.</span>
                  <span class="control-subtitle" [innerHTML]="popoverDonorCoverFeeText"></span>
                </div>
                <div class="d-flex w-100  mb-5 align-items-center col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0 w-100 mr-2">
                    <mdb-select [formControl]="coverFeeSetting"  class="mdb-select">
                      <mdb-option [value]="0">Cover transaction fee</mdb-option>
                      <mdb-option [value]="1">Cover transaction fee and platform fee</mdb-option>
                    </mdb-select>
                    @if(buttons.coverFeeSetting){
                      <div class="position-absolute" style="right: 15px; bottom: -25px;">
                        <a class="body-2 purple-text" (click)="onUpdateClick('coverFeeSetting')">Update</a>
                      </div>
                    }
                  </mdb-form-control>
                </div>
              </div>
              
              <div class="position-relative">
                <div class="d-flex flex-row py-4 mb-3" style="border-top: 1px solid RGB(217, 217, 217);">
                  <div class="d-flex col-4 p-0 flex-column">
                    <span class="control-title">Send Annual Tax Receipts To Donors</span>
                    <span class="control-subtitle mb-1"> We send consolidated annual tax receipts for all donations recorded in PayBee for donors in the third week of January. Everyone is opted in by default.
                      <br><b>You are currently opted {{ optOutOf2020TaxReceipt.value ? 'IN' : 'OUT' }}</b></span>
                  </div>
                  <div class="d-flex w-100  mb-5 align-items-center col-5 p-0 pl-4 position-relative">
                    <app-mdb-switch label=""  class='mr-2' [formControl]="optOutOf2020TaxReceipt"></app-mdb-switch>
                    @if(buttons.optOutOf2020TaxReceipt){
                      <div class="position-absolute" style="left: 25px; bottom: -25px;">
                        <a class="body-2 purple-text" (click)="onUpdateClick('optOutOf2020TaxReceipt')">Update</a>
                      </div>
                    }
                  </div>
                </div>
              </div>
              
            </div>
        </div>
      </div>
    </mdb-tab>
    <mdb-tab title="Donor Pages">
      <div class=" py-4"
        [ngClass]="{
          'read-only': readonly,
          'background__color--white': !readonly
        }">
        @if(readonly){
          <span  class="badge-warning caption custom-budge d-flex align-items-center justify-content-center position-absolute"
          style="top: 30px; right:40px"
          >Read Only Access</span>
        }
        <div class="container pb-5 pl-4" style="margin-bottom: 140px;">
          <div class="mb-4 d-flex flex-column">
            <div class="orgTab-title">Donor Pages</div>
            <span class="orgTab-subtitle">Used for all pages displayed to donors also used in emails sent to donors. <a [href]="orgUrl" target="_blank" class="text-primary"><b>Tap To Preview.</b></a></span>
          </div>
          <div class="w-100 mt-4 new-design-controls">
            <div class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
              <div class="d-flex col-4 p-0 flex-column">
                <span class="control-title">Organization Logo</span>
                <span class="control-subtitle">Displayed to donors in all screens and emails from PayBee.</span>
              </div>
              <div class="d-flex col-7 p-0 pl-4">
                <div  *ngIf="imageDataUrlLogo.value === '/images/blank_2x1.png'" class="d-flex  w-100 flex-column justify-content-center">
                  <div  class="position-relative w-100" style=" height: 150px;">
                    <div
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                    >
                        <app-custom-input-file class="position-absolute custom-input-file" accept="image/png,image/jpeg" label="Select Image" [size]="logoSize" [formControl]="imageFileLogo" [disabled]="readonly"></app-custom-input-file>
                    </div>
                  </div>
                  <span class="text-purple body-2 text-center">OR</span>
                  <a (click)="openChooseImageModal(1,'logo')" class="purple-text body-2 text-center">Choose from previously used images</a>
                </div>

                <img  *ngIf="imageDataUrlLogo.value !== '/images/blank_2x1.png'" style="border-radius: 5px;width: 150px; height: 150px;" [src]="imageDataUrlLogo.value">
                <div class="d-flex flex-column ml-2">
                  <div *ngIf="imageDataUrlLogo.value !== '/images/blank_2x1.png' && !buttons.imageUrlLogo">
                    <span class="remove-btn" style="cursor:pointer;" (click)="resetImage('logo')">Remove</span>
                  </div>
                  @if(buttons.imageUrlLogo){
                    <div class="d-flex flex-column">
                      <a class="mr-3 body-2 grey-text" (click)="onCanselClick('imageUrlLogo')">Cancel</a> 
                      <a class="body-2 purple-text" [ngClass]="imageService.loadingClasses()" (click)="onUpdateClick('imageUrlLogo')">Update</a>
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);border-bottom: 1px solid RGB(217, 217, 217);">
              <div class="d-flex col-4 p-0 flex-column">
                <span class="control-title">Cover Image</span>
                <span class="control-subtitle">Displayed to donors as the campaign image when no campaign image has been set.</span>
              </div>

              <div class="d-flex col-7 p-0 pl-4">
                <div *ngIf="imageDataUrl.value === '/images/blank_2x1.png'" class="d-flex  w-100 flex-column justify-content-center">
                  <div   class="position-relative w-100" style=" height: 150px;">
                    <div
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                    >
                        <app-custom-input-file class="position-absolute custom-input-file" accept="image/png,image/jpeg" label="Select Image" [size]="coverSize" [formControl]="imageFile" [disabled]="readonly"></app-custom-input-file>
                    </div>
                  </div>
                  <span class="text-purple body-2 text-center">OR</span>
                  <a (click)="openChooseImageModal(0,'cover')" class="purple-text body-2 text-center">Choose from previously used images</a>
                </div>

                <img  *ngIf="imageDataUrl.value !== '/images/blank_2x1.png'" style="border-radius: 5px;width: 300px; height: 150px;" [src]="imageDataUrl.value">
                <div class="d-flex flex-column ml-2">
                  <div *ngIf="imageDataUrl.value !== '/images/blank_2x1.png' && !buttons.imageUrl">
                    <span class="remove-btn" style="cursor:pointer;" (click)="resetImage('cover')">Remove</span>
                  </div>
                  @if(buttons.imageUrl){
                    <div class="d-flex flex-column">
                      <a class="mr-3 body-2 grey-text" (click)="onCanselClick('imageUrl')">Cancel</a> 
                      <a class="body-2 purple-text" [ngClass]="imageService.loadingClasses()" (click)="onUpdateClick('imageUrl')">Update</a>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);border-bottom: 1px solid RGB(217, 217, 217);">
              <div class="d-flex col-4 p-0 flex-column">
                <span class="control-title">Page Background Image</span>
                <span class="control-subtitle">Choose a background image to replace the white background on all donor pages to match your branding. When a background image is selected, it replaces the background color.</span>
              </div>

              <div class="d-flex col-7 p-0 pl-4">
                <div  *ngIf="imageDataUrlPageBackgroundImage.value === '/images/blank_2x1.png'" class="d-flex  w-100 flex-column justify-content-center"> 
                  <div  class="position-relative w-100" style=" height: 150px;">
                    <div
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                    >
                        <app-custom-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" [formControl]="imageFilePageBackgroundImage"></app-custom-input-file>
                    </div>
                  </div>
                  <span class="text-purple body-2 text-center">OR</span>
                  <a (click)="openChooseImageModal(0,'pageBg')" class="purple-text  body-2 text-center">Choose from previously used images</a>
                </div>

                <img  *ngIf="imageDataUrlPageBackgroundImage.value !== '/images/blank_2x1.png'" style="border-radius: 5px; height: 150px;" [src]="imageDataUrlPageBackgroundImage.value">
                <div class="d-flex flex-column ml-2">
                  <div *ngIf="imageDataUrlPageBackgroundImage.value !== '/images/blank_2x1.png' && !buttons.pageBackgroundImage">
                    <span class="remove-btn" style="cursor:pointer;" (click)="resetImage('pageBackgroundImage')">Remove</span>
                  </div>
                  @if(buttons.pageBackgroundImage){
                    <div class="d-flex flex-column">
                      <a class="mr-3 body-2 grey-text" (click)="onCanselClick('pageBackgroundImage')">Cancel</a> 
                      <a class="body-2 purple-text" [ngClass]="imageService.loadingClasses()" (click)="onUpdateClick('pageBackgroundImage')">Update</a>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
            <div class="w-100 new-design-controls">
              <div class="d-flex flex-column">
                <div  class="d-flex flex-row py-4">
                  <div class="d-flex col-4 p-0 flex-column">
                    <span class="control-title">Header Color</span>
                    <span class="control-subtitle">Banner is displayed along side the logo to donors in all screens and emails from PayBee.</span>
                  </div>
                  <div class="d-flex w-100 align-items-center  col-5 p-0 pl-4">
                    <div class="d-flex flex-row align-items-center">
                      <input type="color" class="form-control form-control-color" [ngClass]="{ 'disabled': readonly }" [formControl]="bgColor" id="bgColor">
                    </div>
                    @if(buttons.bgColor){
                      <div class="position-absolute" style="right:15;bottom:-20px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('bgColor')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('bgColor')">Update</a>
                      </div>
                    }
                  </div>
                </div>
                <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                  <div class="d-flex col-4 p-0 flex-column">
                    <span class="control-title">Header Text Color</span>
                    <span class="control-subtitle">Banner text is displayed along side the logo to donors in all screens and emails from PayBee. Your organization's name is the text displayed over the banner.</span>
                  </div>
                  <div class="d-flex w-100 align-items-center  col-5 p-0 pl-4">
                    <div class="d-flex flex-row align-items-center">
                      <input type="color" class="form-control form-control-color" [ngClass]="{ 'disabled': readonly }" [formControl]="textColor" id="textColor">
                    </div>
                    @if(buttons.textColor){
                      <div class="position-absolute" style="right:15;bottom:-20px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('textColor')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('textColor')">Update</a>
                      </div>
                    }
                  </div>
                </div>

                <div  class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);">
                  <div class="d-flex col-4 p-0 flex-column">
                    <span class="control-title">Page Background  Color</span>
                    <span class="control-subtitle">Change the background color on all donor pages to match your branding. Default is white.</span>
                  </div>
                  <div class="d-flex w-100 align-items-center  col-5 p-0 pl-4">
                    <div class="d-flex flex-row align-items-center">
                      <input type="color" class="form-control form-control-color" [formControl]="pageBackgroundColor" id="pageBackgroundColor">
                    </div>
                    @if(buttons.pageBackgroundColor){
                      <div class="position-absolute" style="right:15;bottom:-20px">
                        <a class="mr-3 body-2 grey-text" (click)="onCanselClick('pageBackgroundColor')">Cancel</a> 
                        <a class="body-2 purple-text" (click)="onUpdateClick('pageBackgroundColor')">Update</a>
                      </div>
                    }
                  </div>
                </div>
              </div>          
            </div>
        </div>
      </div>
    </mdb-tab>
    <mdb-tab title="Notifications">
      <div class=" py-4"
      [ngClass]="{
        'read-only': readonly,
        'background__color--white': !readonly
      }">
      @if(readonly){
        <span  class="badge-warning caption custom-budge d-flex align-items-center justify-content-center position-absolute"
        style="top: 30px; right:40px"
        >Read Only Access</span>
      }

        <div class="container pb-5 pl-4">
            <div class="w-100 px-3 new-design-controls">
              <div class="mb-4 d-flex flex-column">
                <div class="orgTab-title">Notifications</div>
                <span class="orgTab-subtitle">Add email Ids to be notified for each successful transaction.</span>
              </div>
              <div class="d-flex flex-row py-4" style="border-top: 1px solid RGB(217, 217, 217);border-bottom: 1px solid RGB(217, 217, 217);">
                <div class="d-flex col-4 p-0 flex-column">
                  <span class="control-subtitle">Type an email and press enter to add. Click <strong>X</strong> to remove it.</span>
                </div>
                <div class="d-flex w-100 align-items-center col-5 p-0 pl-4">
                    <div class='position-relative w-100'>
                        <app-chips 
                        data-panel="eMail"
                        [placeholder]="emailPlaceholder" 
                        [elementPattern]="emailPattern" 
                        [formControl]="notifyRecipients"
                        [readonly]="readonly"
                        idChips="notifyRecipients"
                        ></app-chips>
                        @if(!notifyRecipients.valid){<span class="form-fill-error" style="top:60px">Nothing to save. Please type an email and press enter to add.</span>}
                   </div>
                </div>
              </div>
              <button (click)="onUpdateClick('notifyRecipients')" [disabled]="arraysAreEqual(prevNotifyRecipients, notifyRecipients.value)" class="btn btn--paybee modal-confirm-button ml-auto mt-3" [ngClass]="{ 'disabled': readonly }">Save Changes</button>
          </div>
        </div>
      </div>
    </mdb-tab>
    <mdb-tab title="Password">
      <div class="background__color--white py-4">
        <div class="container pb-5 pl-4">
          <div class="mb-4 d-flex flex-column">
            <div class="orgTab-title">Password</div>
            <span class="orgTab-subtitle">Change password for <b>{{loggedInUser ? loggedInUser.name : user.name}}</b> ({{loggedInUser ? loggedInUser.email : user.email}})</span>
          </div>
            <div class="w-100 mt-4 new-design-controls">
              <div class="d-flex flex-row py-4 mb-3" style="border-top: 1px solid RGB(217, 217, 217);">
                <span class="col-4 p-0 control-title">Current password</span>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0">
                    <app-mdbp-input mdbInput [formControl]="oldPass"  [customInput]="true" label=''>
                      <input type="password" [formControl]="oldPass"  autocomplete="off" class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    @if(!oldPass.valid){<span class="form-fill-error">{{getError('oldPass')}}</span>}
                  </mdb-form-control>
                </div>
              </div>
              <div class="d-flex flex-row py-4 mb-3" style="border-top: 1px solid RGB(217, 217, 217);">
                <span class="col-4 p-0 control-title">New password</span>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0">
                    <app-mdbp-input mdbInput [formControl]="newPass"  [customInput]="true"  label=''>
                      <input type="password" [formControl]="newPass"  class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    @if(!newPass.valid){<span class="form-fill-error">{{newPassErr}}</span>}
                  </mdb-form-control>
                </div>
              </div>
              <div class="d-flex flex-row py-4 mb-3" style="border-top: 1px solid RGB(217, 217, 217);border-bottom: 1px solid RGB(217, 217, 217);">
                <span class="col-4 p-0 control-title">Confirm new password</span>
                <div class="col-5 p-0 pl-4">
                  <mdb-form-control class="form-fill mb-0">
                    <app-mdbp-input mdbInput [formControl]="repeatName"  [customInput]="true"  label=''>
                      <input type="password" [formControl]="repeatName"  class="form-control form-control--paybee"/>
                    </app-mdbp-input>
                    @if(!repeatName.valid){<span class="form-fill-error">{{repeatPassErr}}</span>}
                  </mdb-form-control>
                </div>
              </div>
              <div class="d-flex flex-row justify-content-end">
                <button  (click)="onCancelPassword()" class="btn btn--paybee btn--outline-transparent mr-2" >Cancel</button>
                <button (click)="onChangePassword()" [disabled]="oldPass.value.trim() == '' || newPass.value.trim() == '' || repeatName.value.trim() == ''" class="btn btn--paybee modal-confirm-button" >Update password</button>
              </div>
              
            </div>
        </div>
      </div>
    </mdb-tab>
</mdb-tabs> 